import OptionsSwitcher from './options-switcher';

export default OptionsSwitcher;
